module.exports = __webpack_public_path__ + "img/case_4.9188b4e3.png";